const intl = new Intl.DateTimeFormat(navigator.language, {
	hour: '2-digit',
	minute: '2-digit',

	timeZoneName: 'shortGeneric',
})

export default {
	// 0 indexed on January
	getDays(): string[] {
		return [ 'M', 'T', 'W', 'T', 'F', 'S', 'S' ]
	},
	getShortMonth(key: number): string {
		return [
			'Jan',
			'Feb',
			'Mar',
			'Apr',
			'May',
			'Jun',
			'Jul',
			'Aug',
			'Sep',
			'Oct',
			'Nov',
			'Dec',
		][key]
	},
	getLongMonth(key: number): string {
		return [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		][key]
	},
	getDaysInMonth(year: number, month: number): number {
		return new Date(year, month+1, 0).getDate()
	},
	// 0 indexed on Sunday
	getFirstDayInMonth(year: number, month: number): number {
		return new Date(year, month, 0).getDay()
	},
	getDateOrdinal(date: number) {
		let formatted = date.toString(10)
		if (formatted.length === 2 && formatted.charAt(0) === '1')
			return formatted + 'th'

		if (formatted.charAt(formatted.length-1) === '1')
			return formatted + 'st'
		if (formatted.charAt(formatted.length-1) === '2')
			return formatted + 'nd'
		if (formatted.charAt(formatted.length-1) === '3')
			return formatted + 'rd'

		return formatted + 'th'
	},
	getHumanDateDisplay(date: string) {
		let parsed = new Date(date)
		return `${this.getDateOrdinal(parsed.getDate())} of ${this.getShortMonth(parsed.getMonth())}, ${parsed.getFullYear()}`
	},
	getHumanDateDisplayWithHourMinute(date: string) {
		let parsed = new Date(date)
		if (!parsed || parsed.toString() === 'Invalid Date')
			return 'Invalid Date'
		const intlParsed = intl.format(parsed)
		return `${this.getDateOrdinal(parsed.getDate())} of ${this.getShortMonth(parsed.getMonth())}, ${parsed.getFullYear()} at ${intlParsed}`
	},
	getHumanHour(date: string): number {
		let hour = parseInt(date)

		return hour
	}
}
